import Modal from "../General/Modal"
import Image from "next/image"
import { closeEnquirySuccessModal } from "../../store/CoreSlice"
import { useDispatch, useSelector } from "react-redux"
import Button from "./Button"
import { confirmAction, closeConfirmationBox } from "../../store/ConfirmationSlice"

function Confirmation(props : any) {
    const dispatch = useDispatch()
    const {show, details} = useSelector((state : any) => state.confirmation)    

    const handleConfirmAction = () => {
        dispatch(confirmAction())
    }

    const handleClose = () => {
        dispatch(closeConfirmationBox())
    }

    return (
        <Modal show={show} styles='w-[80%] lg:w-1/3'>
            <div className="content pt-4 pb-10 px-3 text-center">
                <h2 className="text-theme-black font-semibold text-2xl">  Bid Confirmation </h2>

                <p className="text-theme-black opacity-70 my-5 text-lg"> { details } </p>

                <div className="flex items-center justify-center">
                    <Button 
                        styles = 'mr-4 text-theme-orange w-[120px] border border-theme-orange py-2' onClick={handleClose}
                        destinationEvent = "Confirmation popup closed"
                    > 
                        Close 
                    </Button>
                    <Button 
                        styles = 'ml-4 bg-theme-orange text-white w-[120px] py-2' onClick={handleConfirmAction}
                        destinationEvent = "Confirmation popup closed"
                    > 
                        Confirm 
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default Confirmation